import { renderInvalidatedColors } from './chart-util';
import * as format from '../data/format';

/**
 * Adds options for BAR and COLUMN charts.
 */

export function preRender(data, options) {
  const bar = data.plotOptions[options.type];
  bar.stacking = options.stacking;
  bar.marker = {
    enabled: false
  };
  bar.borderWidth = 0;
  if (options.horizontalBarType === 'aboveBar') {
    let defaultHeight = 263;
    if (options.product === 'barrons') defaultHeight = 251;
    if (options.product === 'mansionglobal') defaultHeight = 225;
    if (options.product === 'marketwatch') defaultHeight = 231;
    if (options.product === 'financialnews') defaultHeight = 231;
    if (options.product === 'knewz') defaultHeight = 251;
    let scaleFrom400 = options.height / defaultHeight < 1 ? options.height / defaultHeight : defaultHeight / options.height;
    scaleFrom400 = options.height === defaultHeight ? 0.8 : scaleFrom400
    data.plotOptions[options.type].pointPadding = 0.2 / scaleFrom400;
    data.plotOptions[options.type].groupPadding = options.series.length > 1 && 
      options.stacking === null ? 0.2 / scaleFrom400 : 0;
    // data.plotOptions[options.type].pointWidth = 15;
  } else {
    data.plotOptions[options.type].pointPadding = 0.2;
    data.plotOptions[options.type].groupPadding = options.series.length > 1 && 
      options.stacking === null ? 0.2 : 0;
    // data.plotOptions[options.type].pointWidth = 15;
  }

  if (options.type === 'bar') {
    if (options.horizontalBarType === 'aboveBar' || options.horizontalBarType === 'noScaleAndLeft') {
      const hasPrefix = options.tooltips.prefix ? 1 : 0;
      let firstBarLength = options.series[0].data[0].y.toString().length + hasPrefix;
      firstBarLength = firstBarLength > 3 ? firstBarLength + firstBarLength : firstBarLength;
      let defaultOffset = firstBarLength === 1 ? 20 : 30 + (firstBarLength * 2);
      data.plotOptions[options.type].dataLabels = {
        enabled: true,
        align: 'right',
        allowOverlap: true,
        padding: 0,
        style: {
          fontFamily: options.styles.font.normal,
          fontWeight: options.styles.weight.normal,
          fontSize: options.styles.dataLabel.fontSize,
          lineHeight: options.styles.dataLabel.lineHeight,
          textOutline: false,
          shadow: false,
          color: 'black'
        },
        x: options.horizontalBarLabel ? -5 : defaultOffset, // if I set to this to 0 it sits inside the bar,
        y: 4,
        formatter() {
          return formatter(data, options, this);
        }
      }
    }
  }
  data.plotOptions.series = {
    dataGrouping: {
      enabled: !options.irregularDates
    }
  }
  return data;  
}

function formatter(data, options, context) {
  let dataLabel = context.y;
    let value = format.applyFull(context.point.y, false, false, true, true, true);
    // const value = format.applyFull(context.point.y, options.tooltips, options.type === 'pie', true, true);
    const prefix = options.axes.units.prefix;
    const suffix = options.axes.units.suffix;
    if (context.point.index === 0) {
      if (prefix) {
        value = options.axes.units.prefix + value;
      }
      
      if (suffix) {
        value = value + suffix;
      }
    }

    return value;
}

// For bar charts, tweaks the spacing between bars.
// function adjustBarsWidth(data, options) {
//   if (options.type === 'column') {
//     const c = data.plotOptions[options.type];
//     const seriesLen = options.stacking ? 1 : data.series.length;
//     let maxDataLen = 0;
//     data.series.forEach(item => {
//       maxDataLen = Math.max(maxDataLen, item.data.length);
//     });
//     const yAxisEstimate = getYAxisEstimatedWidth(data, options);
//     const xAxisWidth = options.width - yAxisEstimate;
//     const bars = seriesLen * maxDataLen;
//     const groupBars = (seriesLen > 1) ? (maxDataLen - 1) : 0;
//     const pointBars = (seriesLen === 1) ? (maxDataLen - 1) :
//       (maxDataLen * (seriesLen - 1));

//     const adjustedGroupBars = groupBars * 2;
//     // designed = 0.25 :
//     const adjustedPointBars = pointBars * (0.35 + 0.2 * seriesLen);

//     c.pointWidth = Math.max(2, xAxisWidth /
//       (bars + adjustedGroupBars + adjustedPointBars));
    
//     // if (options.legend.enabled && options.legend.layout === 'right') {
//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.25);
//     // } else {
//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.5)
//     // }
    

//     // let factorToSubtractBy = 0;

//     // if (data.series[0].data.length > 100) {
//     //   if (options.width < 500) {
//     //     factorToSubtractBy = 0.95;
//     //   }
//     //   if (options.width < 620 && options.width > 500) {
//     //     factorToSubtractBy = 0.75;
//     //   }
//     //   if (options.width >= 620) {
//     //     factorToSubtractBy = 0.25;
//     //   }
//     // }

//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length > 100) {
//     //   if (options.width < 500) {
//     //     factorToSubtractBy = 0.95;
//     //   }
//     //   if (options.width < 620 && options.width > 500) {
//     //     factorToSubtractBy = 0.9;
//     //   }
//     //   if (options.width === 620) {
//     //     factorToSubtractBy = 0.7;
//     //   }
//     //   if (options.width > 620) {
//     //     factorToSubtractBy = 0.25;
//     //   }
//     // }

//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length < 100) {
//     //   factorToSubtractBy = options.width < 420 ? 0.35 : 0.25;
//     // }
    
//     // c.pointWidth = c.pointWidth - (c.pointWidth * factorToSubtractBy);
//     // c.pointPadding = 0.5;
//     // c.groupPadding = 0;
    
//   }
//   return data;
// }

// NEVER CALLED
// function getYAxisEstimatedWidth(data, options) {
//   let maxNum = 0;
//   data.series.forEach(series => {
//     for (let i = 0; i < series.data.length; i++) {
//       maxNum = Math.max(maxNum, series.data[i].y);
//     }
//   });
//   maxNum = (Math.round(maxNum) + '').length;
//   const units = options.axes.units;
//   const forceDecimals = (units.forceDecimals !== undefined) ?
//     units.forceDecimals : 0;
//   const maxDecimals = (units.maxDecimals !== undefined) ?
//     units.maxDecimals : Number.MAX_VALUE;
//   const len = maxNum + Math.min(forceDecimals, maxDecimals);
//   const fontSize = parseFloat(options.styles.normal.fontSize) * 0.5;
//   return len * fontSize;
// }

export function postRender(highchart, options) {
  if (options.type === 'column') {
    adjustBarSpacing(highchart, options);
  }
  stylizeStacks(highchart, options);
}

export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    renderInvalidatedColors(rendered, invalidated);
  }
}

// Tweak spacing to improve rounding/pixel issues.
function adjustBarSpacing(highchart, options) {
  const axis = highchart.yAxis[0];
  const delta = {
    index1: -1,
    index2: -1,
  };
  // Set X for each bar to NOT rounded position. I thought this would look
  // terrible, but it's fine.
  const seriesLen = axis.series.length;
  axis.series.forEach(series => {
    for (let i = 0; i < series.data.length; i++) {
      const point = series.data[i];
      if (point.graphic) {
        point.graphic.element.setAttribute('x', point.barX);
        // Measure the distance between bars:
        if (delta.index1 === -1) {
          delta.index1 = i;
          delta.bar1 = point.barX;
        } else if (delta.index2 === -1) {
          if (delta.index1 < i - 1) {
            delta.index1 = -1;
          } else {
            delta.index2 = i;
            delta.bar2 = point.barX - point.pointWidth;
          }
        }
      }
    }
  });
  // if (delta.index1 !== -1 && delta.index2 !== -1) {
  //   // If bars are too close together, merge them:
  //   const deltaPx = delta.bar2 - delta.bar1;
  //   console.log(deltaPx);
  //   const hasOverOneFiftyDataPoints = options.series[0].data.length > 150 ? 1.5 : 0.5;
  //   console.log(deltaPx, options.size);
  //   if (deltaPx < hasOverOneFiftyDataPoints) {
  //     axis.series.forEach(series => {
  //       for (let i = 0; i < series.data.length; i++) {
  //         const point = series.data[i];
  //         if (point.graphic) {
  //           let isLegendRight = options.legend.enabled && options.legend.layout === 'right' ? 0.25 : 0.125;
  //           isLegendRight = options.series[0].data.length > 150 ? isLegendRight + 0.05 : isLegendRight;
  //           point.graphic.element.setAttribute('x', point.barX + (deltaPx / 2));
  //           point.graphic.element.setAttribute('width', point.pointWidth - deltaPx);
  //         }
  //       }
  //     });
  //   }
  // }
}

// If stacking is enabled, adjust the style of the stacks.
function stylizeStacks(highchart, options) {
  if (options.stacking) {
    highchart.yAxis[0].series.forEach(series => {
      series.data.forEach(item => {
        if (item.graphic) {
          const el = item.graphic.element;
          const px = parseFloat(el.attributes.height.value);
          if (px > 0) {
            el.setAttribute('height', px - 1);
          }
        }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/chart/inner/chart-bar.js